import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "minScore", "minScoreNumber", "minCulturalScore", "personType", "availableOnly", "city", "sortBy", "resultCount"]

  connect() {
    this.updateResultCount()
  }

  // Automatische Filterung bei Änderungen
  filterChanged(event) {
    // DEBUG: Logge welches Feld geändert wurde
    if (event && event.target) {
      console.log('🔍 Filter geändert:', event.target.name, 'Wert:', event.target.value)
      
      // Prüfe ob min_score unerwartet geändert wird
      if (event.target.name !== 'min_score' && this.hasMinScoreTarget) {
        console.log('📊 Aktueller min_score:', this.minScoreTarget.value)
      }
    }
    
    // Synchronisiere Regler und Zahlenfeld
    if (this.hasMinScoreTarget && this.hasMinScoreNumberTarget) {
      this.minScoreNumberTarget.value = this.minScoreTarget.value
    }
    
    // Verzögerte Filterung für bessere Performance
    clearTimeout(this.filterTimeout)
    this.filterTimeout = setTimeout(() => {
      this.submitForm()
    }, 300)
  }

  // Quick Filter: High Score (80%+)
  quickFilterHighScore() {
    this.minScoreTarget.value = 80
    this.minScoreNumberTarget.value = 80
    this.filterChanged()
  }

  // Quick Filter: Verfügbare Ressourcen
  quickFilterAvailable() {
    this.availableOnlyTarget.checked = true
    this.filterChanged()
  }

  // Quick Filter: Mitarbeiter
  quickFilterEmployees() {
    this.personTypeTarget.value = "Mitarbeiter"
    this.filterChanged()
  }

  // Quick Filter: Freiberufler
  quickFilterFreelancers() {
    this.personTypeTarget.value = "Freiberufler"
    this.filterChanged()
  }

  // Quick Filter: Alle Scores (0%)
  quickFilterAllScores() {
    this.minScoreTarget.value = 0
    this.minScoreNumberTarget.value = 0
    this.filterChanged()
  }

  // Validiere Score-Bereiche
  validateScoreRanges() {
    const minScore = parseInt(this.minScoreTarget.value) || 0
    
    // Stelle sicher, dass min_score im gültigen Bereich liegt
    if (minScore < 0) {
      this.minScoreTarget.value = 0
      this.minScoreNumberTarget.value = 0
    }
    
    if (minScore > 100) {
      this.minScoreTarget.value = 100
      this.minScoreNumberTarget.value = 100
    }
  }

  // Formular absenden
  submitForm() {
    this.formTarget.requestSubmit()
  }

  // Ergebnisanzahl aktualisieren
  updateResultCount() {
    // Diese Methode kann später implementiert werden
    // um die Anzahl der gefilterten Ergebnisse anzuzeigen
  }
} 